import ScrollHint from "scroll-hint";

var myModalEl = document.getElementById("modal-map");

if (myModalEl) {
  myModalEl.addEventListener("shown.bs.modal", function (event) {
    new ScrollHint(".js-scrollable", {
      i18n: {
        scrollable: "スクロールできます",
      },
    });
  });
}
